import { render, staticRenderFns } from "./TemplateChange.vue?vue&type=template&id=67a3f0a0&scoped=true"
import script from "./TemplateChange.vue?vue&type=script&lang=ts"
export * from "./TemplateChange.vue?vue&type=script&lang=ts"
import style0 from "./TemplateChange.vue?vue&type=style&index=0&id=67a3f0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3f0a0",
  null
  
)

export default component.exports